import { List, ListProps } from '@chakra-ui/react';
import React from 'react';

export const CmList: React.FC<ListProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <List {...rest}>{children}</List>;
};
